import { CATEGORY_FILTER_SLUG } from "@/composables/marketplace/useMarketplaceSearch";
import { fetchCategoryByUrl } from "@/services/collection/categories";
import { computedAsync } from "@vueuse/core";
import { useRoute } from "vue-router";

export function useSelectedCategory() {
  const route = useRoute();

  const categorySlug = computed(() => {
    const value = route.query[CATEGORY_FILTER_SLUG];
    return typeof value === "string" && value !== "" ? value : undefined;
  });

  const isCategorySelected = computed(() => categorySlug.value !== undefined);

  const selectedCategory = computedAsync(async () => {
    if (categorySlug.value === undefined) return undefined;
    return fetchCategoryByUrl(categorySlug.value);
  });

  return {
    categorySlug,
    isCategorySelected,
    selectedCategory,
  };
}
